import React from "react";
import { VStack } from "@chakra-ui/react";
import { AccordionItem } from "components";
import { OrganizationSetting } from "../../../../duck";
import { Text, Procedures } from "./components";

interface DisclaimerProps {
  organizationSettings: OrganizationSetting;
}

const Disclaimer: React.FC<DisclaimerProps> = ({ organizationSettings }) => {
  return (
    <AccordionItem title="Disclaimer">
      <VStack align="left" spacing={6}>
        <Text
          organizationSettingId={organizationSettings._id}
          disclaimerText={organizationSettings.disclaimerText}
        />
        <Procedures
          organizationSettingId={organizationSettings._id}
          procedures={
            organizationSettings.disclaimerProcedureSettings?.collection || []
          }
        />
      </VStack>
    </AccordionItem>
  );
};

export default Disclaimer;
